import axios from 'axios';
import { API_URL } from './apiUrl';


const api = axios.create({
    baseURL: API_URL,
});

export async function fetchBlogPosts() {
    const response = await api.get('/blogs');
    return response.data;
}
